import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';
import { BookingStatus } from '@/features/chat/model';

export const updateBooking = async (
  bookingId: string,
  newStatus: BookingStatus,
) =>
  await apiClient.post(`${ENDPOINTS.BOOKINGS}/update`, {
    bookingId,
    newStatus,
  });
